/**
   If the Killswitch is not associated with the recipeId, then we can give a name in the value. That would be considered as the customKillswitch
   for eg. '1000-21': 'customKillswitch'
 */
export default {
  '2054-21': 'isPriceSimplificationEnabled',
  '2054-22': 'isPriceSimplificationVarient2Enabled',
  '2054-23': 'isPriceSimplificationVarient3Enabled',
  '2054-24': 'isPriceSimplificationVarient4Enabled',
  '2054-25': 'isPriceSimplificationVarient5Enabled',
  '2054-26': 'isPriceSimplificationVarient6Enabled',
  '2054-27': 'isPriceSimplificationVarient7Enabled',
  '2054-34': 'isPriceSimplificationVarient34Enabled',
  '2054-36': 'isPriceSimplificationVarient36Enabled',
};
